var branchSlug = typeof process !== 'undefined' && process.env ? process.env.AGG_BRANCH_SLUG : undefined;
export var aggPathname = "/gateway/api/graphql".concat(branchSlug ? "/".concat(branchSlug, "/graphql") : '');
export var getAggEndpoint = function getAggEndpoint(request) {
  var _cacheConfig$metadata;
  var cacheConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var endpoint = aggPathname;
  if ((_cacheConfig$metadata = cacheConfig.metadata) !== null && _cacheConfig$metadata !== void 0 && _cacheConfig$metadata.META_SLOW_ENDPOINT) {
    endpoint = "".concat(endpoint, "/slow");
  }
  if (request.id != null) {
    endpoint = "".concat(endpoint, "/pq/").concat(request.id);
  }
  return "".concat(endpoint, "?operation=").concat(request.name);
};
export var getRequestBody = function getRequestBody(request, variables) {
  var requestBody = {
    operationName: request.name,
    variables: variables
  };
  return JSON.stringify(requestBody);
};